import request from '@/config'
import { AccountSchema, AccountSearch, LoginModel, UserSearch } from './accounts.type';

enum Apis {
    UserDpList = `/api/sysuser/getuserdropdownlist`,
    LoginByWechat = `/api/sysuser/loginbywechat`,
}

export const GetUserDpListApi = (): Promise<IResponse> => request.post({
    url: Apis.UserDpList,
    data: {}
})

/* 系统用户：查询(LIST) */
export const GetAccountList = (searchIpt: AccountSearch = { page_size: 10, current: 1, tenant_id: 1 }): Promise<IResponse> => {
    return request.post({ url: '/api/SysUser/GetSysUserPage', data: searchIpt })
}

/* 系统用户：创建(CREATE) */
export const CreateAccountApi = (createIpt: AccountSchema): Promise<IResponse> => {
    return request.post({ url: '/api/SysUser/InsertSysUser', data: createIpt })
}

/* 系统用户：修改(Modify) */
export const ModifyAccountApi = (modifyIpt: AccountSchema): Promise<IResponse> => {
    return request.post({ url: '/api/SysUser/UpdateSysUser', data: modifyIpt })
}

/* 系统用户：删除(Delete) */
export const DelAccountApi = (rowId: string): Promise<IResponse> => {
    const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: rowId };
    return request.post({ url: '/api/SysUser/DeleteSysUser', data: delParams })
}

/* 系统用户：获取详细(Detail) */
export const GetAccountDetail = (rowId: string): Promise<IResponse> => {
    const delParams = { tenant_id: 1, revision: 0, deleted_user_id: 1, id: rowId };
    return request.post({ url: '/api/SysUser/GetSysUserInfo', data: delParams })
}

/* 用户登录(Erp实现) */
export const AccountLoginApi = (login: LoginModel): Promise<IResponse> => {
    return request.post({ url: '/api/sysuser/login', data: login })
}

/* 用户选择列表查询 */
export const UserSelectListApi = (search: UserSearch): Promise<IResponse> => {

    return request.post({ url: '/api/sysuser/getselectuser', data: search })

}

/* 企业微信登录 */
export const LoginByWechatApi = (login: any): Promise<IResponse> =>
    request.post({
        url: Apis.LoginByWechat,
        data: login
    })
